import { Box, Stack, Switch } from '@chakra-ui/react';
import { useFeatureToggles, useSharedState } from '@xmcloud/hooks';
import { CONTENT_TRANSFER } from '@xmcloud/hooks/context/useSharedState';
import { settings } from '@xmcloud/core/messages/en';
import { useFeature } from 'app/feature-flag/features';
import { CardBox, Text } from 'app/shared-components';
import { useId } from 'react';

const contentTransferToggleTitle = 'Content Transfer';

export const FeatureTogglesPage: React.FC = () => {
	const decoupledHeadingId = useId();
	const contentTransferHeadingId = useId();
	const createProjectV3 = useFeature('CreateProjectV3');
	const contentTransfer = useFeature('ContentTransfer');

	const {
		useDecoupledDeployments,
		setUseDecoupledDeployments,
		contentTransferExpFeat,
		setContentTransferExpFeature,
	} = useFeatureToggles();
	const { setState: setContentTransferEnabled } = useSharedState(
		CONTENT_TRANSFER,
		contentTransferExpFeat,
	);
	const noFeatureToggles = !createProjectV3 && !contentTransfer;

	if (noFeatureToggles)
		return (
			<Box
				width="full"
				alignItems="center"
				display="flex"
				justifyContent="center"
				pt="5%"
			>
				<Text fontWeight="semibold" text="No feature toggles found" />
			</Box>
		);

	return (
		<Stack spacing="4">
			{createProjectV3 && (
				<CardBox
					title={settings.decoupledDeploymentsTitle}
					description={settings.decoupledDeploymentsDescription}
					headingId={decoupledHeadingId}
				>
					<Switch
						aria-labelledby={decoupledHeadingId}
						isChecked={useDecoupledDeployments}
						onChange={(e) => {
							setUseDecoupledDeployments(e.target.checked);
						}}
					/>
				</CardBox>
			)}
			{contentTransfer && (
				<CardBox
					title={contentTransferToggleTitle}
					description="Transfer content between instances"
					headingId={contentTransferHeadingId}
				>
					<Switch
						aria-labelledby={contentTransferHeadingId}
						isChecked={contentTransferExpFeat}
						onChange={(e) => {
							setContentTransferExpFeature(e.target.checked);
							setContentTransferEnabled(e.target.checked);
						}}
					/>
				</CardBox>
			)}
		</Stack>
	);
};
